import React from 'react';
import styled from 'styled-components';

interface AddCardButtonProps {
  onClick: () => void;
}

const StyledButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #2196f3;
  color: white;
  font-size: 24px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  &:hover {
    background-color: #1976d2;
  }
`;

const AddCardButton: React.FC<AddCardButtonProps> = ({ onClick }) => {
  return (
    <StyledButton onClick={onClick} title="新しいカードを追加">
      +
    </StyledButton>
  );
};

export default AddCardButton; 